import React from 'react';
import {
	Document,
	Page,
	Text,
	View,
	StyleSheet,
	Image,
	Svg,
	Path,
} from '@react-pdf/renderer';
import Logo from '../assets/images/Logo.png';
import { StarReIcon } from '../assets/icons/Icons';

const PlanSection = ({
	label,
	content,
	halfWidth = false,
	bgColor,
	txtColor,
}) => {
	function extractDateAndNote(str) {
		const regex = /^(\d{2}\/\d{2}\/\d{2}|\d{4}-\d{2}-\d{2})[:\s-]*(.*)$/;
		const match = str.match(regex);

		if (match) {
			return {
				date: match[1],
				note: match[2].trim(),
			};
		}

		return { date: null, note: str }; // no date found
	}

	if (['Reviews', 'reviews'].includes(label)) {
		return (
			<View
				style={{
					width: '100%',
					flexWrap: 'wrap',
					marginVertical: 5,
				}}>
				<View
					style={{
						width: '100%',
						justifyContent: 'space-between',
						flexDirection: 'row',
					}}>
					<Text
						style={{
							color: txtColor ? txtColor : '#303437',
							fontSize: 11,
						}}>
						{label}
					</Text>
					<View style={{ flexDirection: 'row' }}>
						{Array.from({ length: 5 }).map((_, index) => {
							return (
								<Svg
									key={index}
									width="10"
									height="10"
									viewBox="0 0 10 10">
									<Path
										d="M4.75586 0L6.58387 2.48396L9.51114 3.45492L7.71364 5.96104L7.69479 9.04508L4.75586 8.11L1.81693 9.04508L1.79807 5.96104L0.000576973 3.45492L2.92785 2.48396L4.75586 0Z"
										fill="#FFCC00"
									/>
								</Svg>
							);
						})}
					</View>
				</View>
				<View
					style={{
						marginTop: 5,
						flexDirection: 'row',
						flexWrap: 'wrap',
						width: '100%',
					}}>
					{content.map((text, val) => {
						return (
							<View
								key={val}
								style={{
									maxWidth: '24%',
									border: '1px solid #E2E5ED',
									borderRadius: 5,
									padding: 10,
									marginVertical: 2,
									backgroundColor: '#FFFFFF',
									marginRight: 5,
								}}>
								<Text
									style={{
										fontSize: 9,
										color: '#465967',
									}}>
									{extractDateAndNote(text).note}
								</Text>
								<Text
									style={{
										fontSize: 8,
										color: '#B6BCCB',
										alignSelf: 'flex-end',
										marginTop: 5,
									}}>
									{extractDateAndNote(text).date}
								</Text>
							</View>
						);
					})}
				</View>
			</View>
		);
	} else {
		return (
			<View
				style={{
					width: halfWidth ? '50%' : '100%',
					border: `${halfWidth ? '0px' : '1px'} solid #E2E5ED`,
					borderRadius: 5,
					padding: 10,
					marginVertical: 5,
					backgroundColor: bgColor ? bgColor : '#FFFFFF',
					marginRight: halfWidth ? 2 : 0,
					alignSelf: 'flex-start',
					flexGrow: 0,
				}}>
				<Text
					style={{
						color: txtColor ? txtColor : '#303437',
						fontSize: 11,
					}}>
					{label}
				</Text>
				<View style={{ marginTop: 5 }}>
					{content.map((text, val) => {
						return (
							<View key={val} style={styles.firstSubView}>
								<Text
									style={{
										fontSize: 9,
										color: txtColor ? txtColor : '#465967',
									}}>
									•
								</Text>
								<Text
									style={{
										fontSize: 9,
										color: txtColor ? txtColor : '#465967',
										marginLeft: 5,
									}}>
									{text}
								</Text>
							</View>
						);
					})}
				</View>
			</View>
		);
	}
};

export const PlanDocument = ({ documentData, elderId, elderName, title }) => (
	<Document>
		{documentData.map((item, itemIndex) => {
			return (
				<Page key={itemIndex} size="A4" style={styles.page}>
					{itemIndex === 0 && (
						<View
							style={{
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'space-between',
							}}>
							<View style={styles.section}>
								<Text
									style={{
										color: '#303437',
										fontSize: 12,
									}}>
									{elderName}
								</Text>
								<Text
									style={{
										color: '#6B7BA5',
										fontSize: 8,
									}}>{`Elder ID: ${elderId}`}</Text>
							</View>
							<Text style={{ color: '#303437', fontSize: 16 }}>
								{title}
							</Text>
							<Image
								src={Logo}
								style={{ width: 100, height: 20 }}
							/>
						</View>
					)}
					<View style={styles.sectionBottom}>
						<Text
							style={{
								marginVertical: 5,
								color: '#28696D',
								fontSize: 16,
							}}>
							{item.title}
						</Text>
						<View style={{ width: '100%' }}>
							{item.bodyContent[0] && (
								<PlanSection
									label={item.bodyContent[0].label}
									content={item.bodyContent[0].content}
								/>
							)}
							{item.bodyContent[1] && (
								<PlanSection
									label={item.bodyContent[1].label}
									content={item.bodyContent[1].content}
								/>
							)}
							<View
								style={{ flexDirection: 'row', width: '100%' }}>
								{item.bodyContent[2] &&
								!['Reviews', 'reviews'].includes(
									item.bodyContent[2].label.toLowerCase(),
								) ? (
									<PlanSection
										label={item.bodyContent[2].label}
										content={item.bodyContent[2].content}
										halfWidth={true}
										bgColor={'#28696D'}
										txtColor={'#FFFFFF'}
									/>
								) : (
									<View style={{ width: '50%' }} />
								)}
								{item.bodyContent[3] &&
								!['Reviews', 'reviews'].includes(
									item.bodyContent[2].label.toLowerCase(),
								) ? (
									<PlanSection
										label={item.bodyContent[3].label}
										content={item.bodyContent[3].content}
										halfWidth={true}
										bgColor={'#01C6B2'}
									/>
								) : (
									<View style={{ width: '50%' }} />
								)}
							</View>
							{item.bodyContent.map((key, index) => {
								if (index <= 1) {
									return null;
								}
								if (
									(index === 2 || index === 3) &&
									key.label.toLowerCase() !== 'reviews'
								) {
									return null;
								}

								return (
									<PlanSection
										key={index + 2}
										label={key.label}
										content={key.content}
										halfWidth={false}
									/>
								);
							})}
						</View>
					</View>
				</Page>
			);
		})}
	</Document>
);

const styles = StyleSheet.create({
	page: {
		backgroundColor: '#FFFFFF',
		padding: 10,
	},
	section: {
		marginHorizontal: 10,
		marginVertical: 5,
	},
	subSection: {
		marginHorizontal: 10,
	},
	sectionBottom: {
		marginBottom: 10,
		marginHorizontal: 10,
	},
	docTitle: {
		fontSize: 16,
		fontWeight: 'bold',
		color: '#000000',
		textAlign: 'center',
	},
	heading: {
		fontSize: 14,
		fontWeight: 'bold',
		color: '#28696D',
	},
	subHeading: {
		fontSize: 12,
		color: '#28696D',
		fontWeight: '700',
	},
	text: {
		fontSize: 10,
		color: '#444444',
	},
	subText: {
		fontSize: 10,
		color: '#444444',
		paddingTop: '2px',
	},
	bulletText: {
		marginHorizontal: 5,
		fontSize: 10,
		color: '#000000',
		paddingTop: '2px',
	},
	subView: {
		flexDirection: 'row',
		paddingHorizontal: 10,
	},
	firstSubView: {
		flexDirection: 'row',
		paddingTop: 5,
		paddingHorizontal: 10,
	},
});
